import type { ReactNode } from 'react'
import React from 'react'
import { Icon } from '../Icon'
import { Stack } from 'react-bootstrap'

export type EmptyContentProps = {
  icon?: ReactNode
  message?: ReactNode
  subMessage?: ReactNode
  action?: React.ReactNode
}

const IconComponent = ({ icon }: { icon: string }) => {
  return (
    <div className="text-muted mb-3" style={{ fontSize: 64 }}>
      <Icon name={icon} />
    </div>
  )
}

export const EmptyContent = ({
  icon = 'laptop',
  message = 'No content for now',
  subMessage,
  action,
}: EmptyContentProps) => {
  const component = typeof icon === 'string' ? <IconComponent icon={icon} /> : icon
  return (
    <Stack className=" justify-content-center align-items-center my-2  ">
      {component}
      <h2 className="text-body-secondary mb-2">{message}</h2>
      <div className="text-muted mb-4">{subMessage}</div>
      <div className="mt-3 ">{action}</div>
    </Stack>
  )
}
